import { useCallback } from "react";
import { useCopilotChatConfiguration } from "@copilotkit/react-core/v2";

/**
 * Opens the OneThing chat sidebar from anywhere in the app. Nothing is sent:
 * the user types their own request (the welcome screen restores history).
 *
 * Needs the outer CopilotChatConfigurationProvider in CopilotProvider — pages
 * sit outside the sidebar's own provider, so without it `setModalOpen` is absent.
 */
export function useOpenOneThingChat() {
  const setModalOpen = useCopilotChatConfiguration()?.setModalOpen;
  return useCallback(() => setModalOpen?.(true), [setModalOpen]);
}
